<ix-icon name="info"></ix-icon>
<span class="message">
  {{ 'You are using an insecure connection. Switch to HTTPS for secure access.' | translate }}
</span>
